<template>
    <div class="mobile-chat-wrapper">
        <div style="padding: 20px">
            <p style="color: #fff;font-size: 15px;margin-bottom: 5px">可选AI模型:</p>
            <div style="display: flex;align-items: center;">
                <div  @click="aiModel = item.type" style="margin-right: 20px;cursor: pointer;padding: 5px;color: #fff" :class="{'active':aiModel === item.type}" v-for="item in aiModels" :key="item.type">
                    <img style="height: 40px" :src="item.icon" alt="">
                    <p>{{item.text}}</p>
                </div>
            </div>
        </div>
        <div v-if="JSON.stringify(programmeInfo) !== '{}' && programmeInfo.number" style="font-size: 16px;color: #fff;padding:0 20px">
            出发日期：{{programmeInfo.startDate}} 返程日期：{{programmeInfo.endDate}} 预估人数：{{programmeInfo.number}}
        </div>
        <div class="chat-history">
            <div ref="chatContent" class="chat-content">
                <div v-for="(item, index) in chatList" :key="item.id" class="chat-wrapper">
                  <div v-if="index!=0">
                    <div v-if="item.role === 'assistant'" class="chat-friend">
                      <div class="info-time">
                        <img :src="item.headImg" alt=""/>
                        <span>{{ item.name }}</span>
                        <span>{{ item.time }}</span>
                      </div>
                      <div v-if="item.role === 'assistant'" :ref="'chatText_' + index" class="chat-text"
                           @click="checkText(item.content,$event)">
                        <template v-if="(!item.content && !item.reasoning) && isSend">
                          <span class="flash_cursor"></span>
                        </template>
                        <template v-else>
                          <div style="margin-bottom: 12px">
                            <p style="margin-bottom: 6px">推理：</p>
                            <p style="color: #e5e5e5"  v-html="item.reasoning"></p>
                          </div>
                          <p v-if="item.content" style="margin-bottom: 6px">正文：</p>
                          <p v-html="item.content"></p>
                        </template>
                      </div>
                      <!--                        <div v-if="item.chatType == 1" class="chat-img">-->
                      <!--                            <img v-if="item.extend.imgType == 1" :src="item.msg" alt="表情"-->
                      <!--                                 style="width: 100px; height: 100px"/>-->
                      <!--                            <el-image v-else :preview-src-list="srcImgList" :src="item.msg"></el-image>-->
                      <!--                        </div>-->
                      <!--                        <div v-if="item.chatType == 2" class="chat-img">-->
                      <!--                            <div class="word-file">-->
                      <!--                                <FileCard :file="item.msg" :fileType="item.extend.fileType"></FileCard>-->
                      <!--                            </div>-->
                      <!--                        </div>-->
                    </div>
                    <div v-else class="chat-me">
                      <div class="info-time">
                        <span>{{ item.name }}</span>
                        <span>{{ item.time }}</span>
                        <img :src="item.headImg" alt=""/>
                      </div>
                      <div v-if="item.role === 'user'" class="chat-text">
                        {{ item.content }}
                      </div>
                      <!--                        <div v-if="item.chatType == 1" class="chat-img">-->
                      <!--                            <img v-if="item.extend.imgType == 1" :src="item.msg" alt="表情"-->
                      <!--                                 style="width: 100px; height: 100px"/>-->
                      <!--                            <el-image v-else :preview-src-list="srcImgList"-->
                      <!--                                      :src="item.msg" style="max-width: 300px; border-radius: 10px"></el-image>-->
                      <!--                        </div>-->
                      <!--                        <div v-if="item.chatType == 2" class="chat-img">-->
                      <!--                            <div class="word-file">-->
                      <!--                                <FileCard :file="item.msg" :fileType="item.extend.fileType"></FileCard>-->
                      <!--                            </div>-->
                      <!--                        </div>-->
                    </div>
                  </div>

                </div>
            </div>
        </div>
        <div class="chat-input-wrapper">
            <el-input :disabled="isSend" v-model="inputMsg"/>
            <el-select style="margin-left: 5px" @change="clearChat" v-model="chatType" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <img  v-if="isSend" alt="" class="send-icon" src="@/assets/img/emoji/zhongzhi.png" @click="abortFetch">
            <img  v-else alt="" class="send-icon" src="@/assets/img/emoji/rocket.png" @click="sendText">
        </div>
    </div>
</template>

<script>
import {animation} from '@/util/util'
import Api from '../Api/PlanApi'
import {getPlanInfo} from '@/views/plan/js/function.js'
import {mapState} from "vuex";
export default {
    name: 'MobileChat',
    data() {
        return {
            chatList: [],
            inputMsg: '',
            streamedData:'',
            chatType:1,//正常聊天
            isSend: false,//是否接受完毕
            // 用于存储终止函数
            abortController: false,
            options: [{
                value: 0,
                label: '正常对话'
            }, {
                value: 1,
                label: '生成行程'
            },{
                value: 3,
                label: '行程优化'
            }],
            aiModels:[
                {
                    icon:require('@/assets/img/baidu.png'),
                    type:2,
                    text:'百度AI'
                },
                {
                    icon:require('@/assets/img/deepseek.png'),
                    type:1,
                    text:'deepseek'
                }
            ],
            aiModel:2
        }
    },
    props: {
        //行程数据
        programmeInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    computed: {
        ...mapState(['accessToken','budgetMainId'])
    },
    created() {
        let _this=this;
        document.onkeydown=function(e){
            let key= window.event.keyCode;
            if(key===13){
               if(_this.isSend) return
                _this.sendText()
            }
        }
    },
    methods: {
        clearChat() {
            this.chatList = []
            this.abortFetch()
        },
        sendTextPost(chatType){ //isOptimization 是否优化行程
          this.chatType = chatType || this.chatType
          let meMsg = {
            headImg: require('@/assets/img/head_portrait.jpg'),
            name: '我',
            time: new Date().toLocaleTimeString(),
            role:'user',
            content: this.inputMsg,
            chatType:this.chatType,
          }
          this.chatList.push(meMsg);
          this.fetchData(this.chatList);
          let chatMsg = {
            headImg: require('@/assets/img/head_portrait.jpg'),
            name: 'AI',
            time: new Date().toLocaleTimeString(),
            role:'assistant',
            chatType:chatType,
            reasoning:'',//推理
            content: '',
          }
          this.chatList.push(chatMsg);
          // this.scrollBottom()

        },
        sendText() {
            if (this.inputMsg) {
                this.sendTextPost()
                this.inputMsg = ''
            } else {
                this.$message({
                    message: '消息不能为空哦~',
                    type: 'warning'
                })
            }
        },
        abortFetch() {
            if (this.abortController) {
                // 调用终止函数
                this.abortController.abort()
            }
        },
        async fetchData(msgList) {
            this.abortController = new AbortController();
            const signal = this.abortController.signal;
            this.isSend = true;
            let obj = {
                type:this.aiModel,
                message:msgList,
                planInfo: {
                    startDate: this.programmeInfo.startDate,
                    endDate: this.programmeInfo.endDate,
                    number: this.programmeInfo.number
                }
            }
            //如果是第一次发送
            if (msgList.length === 1) {
                obj.planInfo = {...obj.planInfo,...this.programmeInfo}
                if(this.chatType === 3) { //行程优化
                    obj.budgetMainId = this.budgetMainId
                }
            }
            try {
                const response = await fetch(`${process.env.VUE_APP_SERVE}/sse`, {
                method: "POST",
                    body: JSON.stringify(obj),
                    headers: {
                        Authorization:'bearer ' +  this.accessToken
                    },
                    signal: signal
                });

                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');

                while (true) {
                    if (signal.aborted) {
                        this.isSend = false;
                        console.log('请求已手动终止');
                        break;
                    }

                    const { done, value } = await reader.read();
                    if (done) {
                        this.isSend = false;
                        break;
                    }
                    const chunk = decoder.decode(value, { stream: true });
                    console.log(chunk,'推过来的数据')
                    if(chunk.includes('dataReasoning')) {
                        this.chatList[this.chatList.length - 1].reasoning += chunk.replaceAll('dataReasoning: ', '')
                        console.log(this.chatList[this.chatList.length - 1].reasoning,'sadlsldlsdlls')
                    }else {
                         this.chatList[this.chatList.length - 1].content += chunk.replaceAll('data: ', '')
                    }
                    this.scrollBottom()
                }
            } catch (error) {
                if (error.name === 'AbortError') {
                    console.log('请求被手动中止');
                } else {
                    console.error('请求失败:', error);
                }
                this.isSend = false;
            }
        },
        //获取窗口高度并滚动至最底层
        scrollBottom() {
            this.$nextTick(() => {
                const scrollDom = this.$refs.chatContent
                animation(scrollDom, scrollDom.scrollHeight - scrollDom.offsetHeight)
            })
        },
        checkText(msg, e) {
            if(this.isSend) {
                this.$message.warning('请在回复完成后再生成行程')
                return
            }
            this.$confirm(`是否以此段文案作为行程的生成标准?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let loading = this.$loading({
                    lock: true,
                    text: "努力生成中,请稍后...",
                    spinner: 'el-icon-phone-outline',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                new Api('plan').aiDistinguish(msg, this.programmeInfo.number).then(res => {
                    if (res.status === 200) {
                        this.$message.success("success")
                        this.$store.commit('setPlanId', res.data.planId)
                        this.$store.commit('setBudgetMainId', null)
                        if (this.$route.path === '/newNavBar/plan') {
                            getPlanInfo(this.$store.state.planId, null)
                        } else {
                            this.$router.push({name: "plan"});
                        }
                        this.$emit('successfullyGenerated')
                    } else {
                        this.$message.error(res.statusText)
                    }
                    loading.close()
                }).catch(() => {
                    this.$message.error("系统异常")
                    loading.close()
                })
            }).catch(() => {
            });
        }
    },
    watch: {
        aiModel() {
            this.chatList = []
            this.abortFetch()
        }
    }
}
</script>

<style lang="scss">
.active {
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    background-color: #fff;
    color: #000 !important;
    border-radius: 10px;
}
.mobile-chat-wrapper {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100vh;
    position: relative;
    background-color: #272a37;

    .chat-history {
        flex: 1 1 0;
        overflow-y: auto;
        padding-top: 20px;
    }

    .chat-input-wrapper {
        display: flex;
        align-items: center;
        padding: 8px 16px 8px 8px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;

        .send-icon {
            height: 40px;
            margin-left: 16px;
            cursor: pointer;
        }
    }
    .chat-content {
        width: 100%;
        height: 85%;
        overflow-y: scroll;
        padding: 20px;
        box-sizing: border-box;

        &::-webkit-scrollbar {
            width: 0;
            /* Safari,Chrome 隐藏滚动条 */
            height: 0;
            /* Safari,Chrome 隐藏滚动条 */
            display: none;
            /* 移动端、pad 上Safari，Chrome，隐藏滚动条 */
        }

        .chat-wrapper {
            position: relative;
            word-break: break-all;

            .chat-friend {
                width: 100%;
                float: left;
                margin-bottom: 20px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;

                .chat-text {
                    max-width: 90%;
                    padding: 20px;
                    border-radius: 20px 20px 20px 5px;
                    background-color: rgb(56, 60, 75);
                    color: #fff;

                    &:hover {
                        cursor: pointer;
                        background-color: green;
                    }

                    pre {
                        white-space: break-spaces;
                    }
                }

                .chat-img {
                    img {
                        width: 100px;
                        height: 100px;
                    }
                }

                .info-time {
                    margin: 10px 0;
                    color: #fff;
                    font-size: 14px;

                    img {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        vertical-align: middle;
                        margin-right: 10px;
                    }

                    span:last-child {
                        color: rgb(101, 104, 115);
                        margin-left: 10px;
                        vertical-align: middle;
                    }
                }
            }

            .chat-me {
                width: 100%;
                float: right;
                margin-bottom: 20px;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-end;

                .chat-text {
                    float: right;
                    max-width: 90%;
                    padding: 20px;
                    border-radius: 20px 20px 5px 20px;
                    background-color: rgb(29, 144, 245);
                    color: #fff;

                    &:hover {
                        background-color: rgb(26, 129, 219);
                    }
                }

                .chat-img {
                    img {
                        max-width: 300px;
                        max-height: 200px;
                        border-radius: 10px;
                    }
                }

                .info-time {
                    margin: 10px 0;
                    color: #fff;
                    font-size: 14px;
                    display: flex;
                    justify-content: flex-end;

                    img {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        vertical-align: middle;
                        margin-left: 10px;
                    }

                    span {
                        line-height: 30px;
                    }

                    span:first-child {
                        color: rgb(101, 104, 115);
                        margin-right: 10px;
                        vertical-align: middle;
                    }
                }
            }
        }
    }

    .flash_cursor {
        width: 20px;
        height: 30px;
        display: inline-block;
        background: #d6e3f5;
        opacity: 1;
        animation: glow 800ms ease-out infinite alternate;
    }

    @keyframes glow {
        0% {
            opacity: 1;
        }

        25% {
            opacity: 0.5;
        }

        50% {
            opacity: 0;
        }

        75% {
            opacity: 0.5;
        }

        100% {
            opacity: 1;
        }
    }
}
</style>
